module.exports = __webpack_public_path__ + "static/media/kasa_desktop.b84c2d8d.webp";